export default __webpack_public_path__ + "static/media/allwaysfree.031fb4d9.svg";